<template>
    <div class="all-employers container">
        <div v-if="busy">Loading...</div>
        <div v-if="!busy && employers.length == 0">No employers</div>
        <div v-if="!busy">
            <v-client-table :data="filteredEmployers" :columns="columns" :options="tableOptions"
                @filter="onFilterChanged" ref="employersGrid">
                <template v-slot:employerName="{ row }">
                    <router-link :to="`/employer/${row.employerId}/main`">{{ row.employerName }}</router-link>
                </template>
                <template v-slot:workflowStatus="{ row }">
                    <div>
                        <span v-for="(link, index) in row.workflowStatus" :key="index">
                            <a v-if="isInternalUser || link.actionRequired" @click="selectWorkflow(link)" href="#">
                                <i v-if="!isInternalUser && link.actionRequired" class="fa fa-clock-o"></i>
                                <span v-if="link.startDate">{{ link.startDate }}</span>
                                {{ link.status }}
                            </a>
                            <span v-else>{{ link.status }}</span>
                            <br />
                        </span>
                    </div>
                </template>
            </v-client-table>
        </div>
    </div>
</template>

<script>
import { formatters } from '../framework';
import GuidanceRegistry from '../guidance/guidance-registry';

export default {
    props: {
        filter: {
            type: String,
            required: false,
            default: "my"
        }
    },
    routeQuery: ['searchText'],
    data() {
        return {
            isLoading: true,
            searchText: null,
            employers: [],
            editableColumns: [],
            tableOptions: {
                ...utils.getVueTablesOptions(),
                skin: "table table-bordered table-condensed table-striped",
                pagination: {
                    chunk: 1000,
                    dropdown: false
                },
                perPageValues: [],
                perPage: 500,
                texts: {
                    filter: null,
                    count: '',
                    filterPlaceholder: "Search by text"
                },
                headings: {
                    employerName: "Employer",
                    amfCode: "Code",
                    participantCount: "Participants",
                    plans: "Plans",
                    brokerName: "Broker",
                    workflowStatus: "Workflow"
                },
            },

        };
    },
    computed: {
        ...amfx.map("session", "isInternalUser"),
        filteredEmployers() {
            return this.employers;
        },
        columns() {
            var showParticipantCount = _.some(this.employers, e => Boolean(e.participantCount));
            var showBroker = _.some(this.employers, e => Boolean(e.brokerName));
            var showWorkflow = _.some(this.employers, e => Boolean(e.workflows));

            var columns = [
                "employerName",
                "amfCode",
                showBroker && "brokerName",
                "plans",
                showParticipantCount && "participantCount",
                showWorkflow && "workflowStatus"
            ];

            return _.compact(columns);
        },
    },
    methods: {
        ...amfx.map("actionItems", ['searchActionItems:search']),
        onFilterChanged(filter) {
            this.searchText = filter;
        },
        getEmployerUrl(employer) {
            return `/employer/${employer.employerId}/general`;
        },
        selectWorkflow(row) {
            if(this.isInternalUser)
                this.filterActionItems(row);
            else
                this.$router.push(`employer/${row.employerId}/main`);
        },
        async filterActionItems(row) {
          await this.searchActionItems({ employerId: row.employerId });
        },
        extendEmployer(employer) {
            if (employer.workflows) {
                employer.workflows = employer.workflows.filter(w => w.type != "legacy-workflow");
                employer.workflowStatus = employer.workflows.map(w => {
                    var actionRequired = !!(w.actionItems && w.actionItems.length);
                    var status = "";
                    var startDate = "";

                    var workflowJSON = getJSON(w.json);
                    if(w.orderEffectiveDate) {
                        startDate = `${formatters.date(w.orderEffectiveDate)} `
                    }
                    else if(workflowJSON && workflowJSON.StartDate) {
                        startDate = `${formatters.date(workflowJSON.StartDate)} `;
                    }

                    if (w.type == "renewal-workflow") status = "Renewal";
                    if (w.type == "new-employer-workflow") status = "New Client";
                    if (w.type == "cobra-rate-workflow") status = "COBRA Rates";
                    if (w.type == "legacy-workflow") status = "COBRA Rates";
                    if (w.status == "completed") status += " (completed " + formatters.date(w.updatedDate) + ")";
                    if (w.status == "pending") status += " pending";

                    var hasActionItems = w.actionItems && w.actionItems.length;

                    if(hasActionItems) {
                        var actionItems = w.actionItems.map(actionItem => {
                            var guidance = GuidanceRegistry.get(actionItem.guidanceItemType);
                            
                            if(guidance && guidance.briefDescription)
                                return guidance.briefDescription;
                            else
                                return actionItem.description;
                        });

                        actionItems = _.compact(actionItems);

                        var pendingText = actionItems.join(', ');

                        if(pendingText)
                            status += `: ${pendingText}`;
                    }
                    else if(!this.isInternalUser && w.status == 'pending' && !hasActionItems) {
                        status += ': Under review by Ameriflex';
                    }

                    return { actionRequired, startDate, status, employerId: employer.employerId, actionItems: w.actionItems }
                });
            }

            if (this.isInternalUser) {
                if (employer.cardProcessor == 2) employer.employerName += " (Fiserv)";
            }
        },
        async load() {
            this.busy = true;
            var employers = await romeApi.get(`employer/my?filter=${this.filter}`);
            employers.forEach(this.extendEmployer);
            this.employers = employers;
            this.busy = false;
            this.$nextTick(() => {
                if(this.searchText)
                    this.$refs.employersGrid.setFilter(this.searchText);
            });
        }
    },
    watch: {
        filter: {
            handler: function(val) {
                this.load();
            },
            immediate: true,
        }
    }
}

function getJSON(value) {
    var object = null;
    try {
        object = JSON.parse(value);
    }
    catch(e) { }

    return object;
}

</script>

<style lang="scss" scoped>
    .all-employers {
        a {
            color: black;
        }
    }
</style>



// WEBPACK FOOTER //
// src/employer/EmployersTable.vue